module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/JE-59ddd34311eff3c6cefe7c4666a3f519.png";